// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2ep4g","upload":"Small_upload__2T21j","imageWrap":"Small_imageWrap__5Rrf7","removeBtn":"Small_removeBtn__mCEdN"};